import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";

import { env } from "../../config/env";
export class LabelsAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${env.rogoApiUrl}/labels`;
	}

	public async getPdfBlob(lab: string, robot: string, tracking: string): Promise<Blob> {
		const response = await apiClient.get(`${this.baseUrl}/pdf`, {
			...StandardAxiosConfig(),
			params: { lab, robot, tracking },
			responseType: "blob",
		});
		return response.data as Blob;
	}
}
